import RemitAddressContainer from "./RemitAddressContainer";
export default RemitAddressContainer;
